import { AxiosResponse } from "axios"
import { coreAxios } from "../axios"
import { Group } from "@/declare/interface/project/group"

export const GroupThumbnailUploadUrl = '/api-core/groups/base64';

export function getGroups(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/groups`, {
        params: {
            ...params,
        }
    })
}

export function getTreeGroups(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/groups/tree`, {
        params: {
            ...params,
        }
    })
}

export function addGroup(projectUuid: string, group: Group, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/groups`, group, {
        params: {
            ...params,
        }
    })
}

export function deleteGroup(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/groups/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function updateGroup(uuid: string, group: Group, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/groups/${uuid}`, group, {
        params: {
            ...params,
        }
    })
}

export function findSecondGroupsByParamType(projectUuid: string, paramType: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/second-groups`, {
        params: {
            ...params,
            paramType: paramType,
        }
    })
}

